let view = null;

export default {
	namespace: 'template-blog',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: BlogView } = await import(/* webpackChunkName: "blog-view" */ '../../templates/BlogView');
		view = new BlogView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
